const AUTH_USER_KEY = 'cso_auth_user';

export function getStoredUser() {
  try {
    const raw = sessionStorage.getItem(AUTH_USER_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

export function setStoredUser(user) {
  sessionStorage.setItem(AUTH_USER_KEY, JSON.stringify(user));
}

export function clearStoredUser() {
  sessionStorage.removeItem(AUTH_USER_KEY);
}

/** Prefer configured profile name, then account name, then email local-part. */
export function resolveUserDisplayName({ profileName, projectName, email } = {}) {
  const fromProfile = String(profileName || '').trim();
  if (fromProfile) return fromProfile;
  const fromProject = String(projectName || '').trim();
  if (fromProject) return fromProject;
  const fromEmail = String(email || '').split('@')[0]?.trim();
  if (fromEmail) return fromEmail;
  return 'Account';
}
